import { useCurrentUser } from '@mp/hooks';
import { isSaasSchedulingAccount } from '@mp/utils';
import { useProfessionalSaasDetail } from './useProfessionalSaasDetail';
import { useSchedulingPrefsConfig } from './useSchedulingPrefsConfig';

export const useSchedulingPreferencesData = () => {
  const { currentUser, isSaas } = useCurrentUser();
  const { professionalSaasDetail } = useProfessionalSaasDetail(currentUser?.professional?.id);
  const { shiftPreferences, dayPreferences, frequencyPreferences, positionPreferences } =
    useSchedulingPrefsConfig();

  const hasSaasDetails = !!professionalSaasDetail?.id;

  const preferencesLastUpdatedAt = professionalSaasDetail?.preferences_last_updated_at;

  const availableLabelOptions = professionalSaasDetail?.available_job_slot_labels ?? [];
  const positionOptions = currentUser?.professional?.positions ?? [];

  const hasAnyStatsigConfigEnabled =
    (shiftPreferences && availableLabelOptions.length > 1) ||
    dayPreferences ||
    frequencyPreferences ||
    (positionPreferences && positionOptions.length > 1);

  const shouldShowSchedulingPreferences =
    isSaas && isSaasSchedulingAccount(currentUser) && hasSaasDetails && hasAnyStatsigConfigEnabled;

  return {
    shouldShowSchedulingPreferences,
    preferencesLastUpdatedAt,
  };
};
